import {
  IonHeader, IonPage, IonToolbar, IonTitle, IonContent, withIonLifeCycle, IonFab, IonFabButton,IonIcon, IonItem, IonRow, IonCardContent, IonCard, IonCol, IonLabel, IonInput, IonRadioGroup,IonRadio, IonCardHeader, IonSelect, IonButton, IonSelectOption,IonBadge, IonRange, IonThumbnail, IonImg
} from '@ionic/react';
import React from 'react';
import * as API from "../utils/api";
import * as apiConstants from "../constants/api-endpoint";
import { Question, Header, ServiceQuestionResponse, CustomTO } from "../interface/question.i";
import { camera, chevronBackSharp} from 'ionicons/icons';
import { Plugins} from '@capacitor/core';
import moment from 'moment';
import Swal from 'sweetalert2';
import styled from "styled-components";
import { CustomerDetail} from "../interface/customerDetails.i";
import { CAMERA } from "../utils/shared";
import LogoutPage from './Logout';
import './Page.css';
import * as commonConstant from "../constants/common";


const { Camera, Filesystem,VoiceRecorder } = Plugins;
  
  class ServiceProgramPage extends React.Component<any, any> {
    
    private selectedData: CustomerDetail;
    private selectedCompartmentType: CustomerDetail;
    private pageNumber: number = 1;
    private currentPageNumber: number = 0;
    private previousPageNumber: number = 0;
    private nextPageNumber: number = 0;
    private rankNumber: number = 1;
    private currentPageRankNumber: number = 0;
    private previousPageRankNumber: number = 0;
    private nextPageRankNumber: number = 0;
    private showphoto: boolean = false;
    
  constructor(props: any) {
    super(props);
    console.log(" props data ==> ", props);
    this.selectedData = props.location.state.userData;
    this.selectedCompartmentType= props.location.state.userData.serviceProgramType; 
    this.state = { data: [] as Question[], selectedData: this.selectedData, selectedCompartment : this.selectedCompartmentType, headerTO:  {} as Header, currentPage: {} as CustomTO, previousPage: {} as CustomTO, nextPage: {} as CustomTO, originalQuestion : {} as ServiceQuestionResponse, photo : []}
  }

  componentDidMount(){
      this.ServiceProgramCompartmentType(this.selectedData.id,this.pageNumber,this.rankNumber);
  }

  updateServiceProgramDetails=()=>{
    this.ServiceProgramCompartmentType(this.selectedData.id,this.nextPageNumber,this.nextPageRankNumber);
    this.getServiceProgramDetails();
}
 
  getServiceProgramDetails=()=>{
    if(this.nextPageNumber != 0){
      const serviceQuestionTOs = this.state.data as Question[];
      serviceQuestionTOs.map((el:Question) => {
      if(el.answerType === 'drop down' || el.answerType == 'drop down hide')
      {
        el.answerValue = el.answerValue.toString();
      }
      if(el.answerType === 'range' || el.answerType == 'drain range')
      {
        el.answerValue = (el.answerValue as string[]).join('-');
        el.label = (el.label as string[]).join('-');
        el.answer = el.answer.toString();
      }
      if((el.answerType === 'multiselect' && el.answer === 'null') || (el.answerType === 'drop down multiple' && el.answer === 'null'))
      {
        el.answer = el.answer.toString();
      }
 });
   
    let update = this.state.originalQuestion;
    let num = this.selectedData.id;
    let name = localStorage.username;
    let currentRankNumber = this.currentPageRankNumber;
    console.log("crn=", currentRankNumber);
    const uploadValues = API.authPostRequest(apiConstants.serviceUpdate + num + '/' + name + '/' + currentRankNumber, update);
    console.log("url",uploadValues);
    uploadValues
      .then(async (res) => {
        console.log('Service Data Updated Successfully',res);
      })
      .catch((error) => {
        console.log("err===", error);
      });
    }
    
    else {
       this.ServiceProgramSubmitButton(this.selectedData.id);
       const serviceQuestionTOs = this.state.data as Question[];
      serviceQuestionTOs.map((el:Question) => {
      if(el.answerType === 'drop down')
      {
        el.answerValue = el.answerValue.toString();
      }
      if(el.answerType === 'range')
      {
        el.answerValue = (el.answerValue as string[]).join('-');
        el.label = (el.label as string[]).join('-');
        el.answer = el.answer.toString();
      }
      if(el.answerType === 'multiselect' && el.answer === 'null')
      {
        el.answer = el.answer.toString();
      }
});
   
    let update = this.state.originalQuestion;
    let num = this.selectedData.id;
    let name = localStorage.username;
    let currentRankNumber = this.currentPageRankNumber;
    const uploadValues = API.authPostRequest(apiConstants.serviceUpdate + num + '/' + name + '/' + currentRankNumber,update);
    console.log("url",uploadValues);
    uploadValues
      .then(async (res) => {
        console.log('Service Data Updated Successfully',res);
      })
      .catch((error) => {
        console.log("err===", error);
      });
    }
  }

  ServiceProgramSubmitButton =(id:number) => {

          Swal.fire({
          title: 'Are you sure you want to submit?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: 'Submit',
          denyButtonText: `Don't Submit`,
        }).then((result) => {
          if (result.isConfirmed) {
            const name = localStorage.username;
            const submit = apiConstants.submitReport + id + '/' + name;
            API.authGetRequest(submit, '')
            .then((res) => {
              const responseData = res.data;
            Swal.fire('Success!', responseData.message ,'success')
            this.props.history.push('/upcoming-schedule?selection=serviceprogramschedule')
            })
          } else {
            Swal.fire('Changes are not saved', '', 'info')
          }
        })
      .catch((error) => {
        console.log("err===", error);
      })
  }
    

  ServiceProgramCompartmentType =(id : number, pageno : number, rankNumber : number) => {
    const val = "Preliminary";
    if((this.props.location.state.userData.serviceNumber == 1 || this.props.location.state.userData.serviceNumber == 2)
    &&(this.props.location.state.userData.spSemiAnnual == 'Yes') || ((this.props.location.state.userData.serviceNumber == 2 || this.props.location.state.userData.serviceNumber == 4)
    &&(this.props.location.state.userData.spQuarterly == 'Yes'))) {
    const url = apiConstants.servicequestions + id  + '&compartmentType=' + val + '/' + this.selectedCompartmentType + '/Notes' + "&page=" + pageno + "&rankNumber=" + rankNumber;
      API.authGetRequest(url, '')
        .then((res) => {
          if(res && res.data){
          const responseData = res.data;
          this.currentPageNumber = responseData.currentPage.mobilePageNumber;
          this.currentPageRankNumber = responseData.currentPage.rankNumber;
          this.previousPageNumber = responseData.previousPage.mobilePageNumber;
          this.previousPageRankNumber = responseData.previousPage.rankNumber;
          this.nextPageNumber = responseData.nextPage.mobilePageNumber;
          this.nextPageRankNumber = responseData.nextPage.rankNumber;
          const data =responseData.serviceQuestionTOs as Question[];
          if(data != null){
          if (data && data.length) {
            data.map((obj:Question) => {
                // Dropdown hide logics based on the service type for property
                if (obj.questionReference == 'info_trtmt_tank' || obj.questionReference == 'info_pump_tank' || obj.questionReference == 'info_peat_moss') {

                  const comparition = commonConstant.SERVICE_TYPE;
                  if (this.props?.location?.state?.userData?.serviceProgramType) {
                    const selectedCompination = this.props.location.state.userData.serviceProgramType.split('/');
                    if (selectedCompination.length) {
                      obj.hideElement = false;
                      selectedCompination.map((el: string) => {
                        if (comparition[el] == obj.questionReference) {
                          obj.hideElement = true;
                        }
                      });
                    }
                  }
              }

              if (obj.answerType === 'range' || obj.answerType == 'drain range') {
                const str = obj.answerValue as string;
                const label = obj.label as string;
                obj.answer = obj.answer ? obj.answer : '0';
                obj.answerValue = str.split('-').map(Number);
                if (label) {
                  obj.label = label.split('-');
                }
              } 
            })
          }
        }
          console.log("allService===", res);
          this.setState({
            headerTO: responseData.headerTO,
            data: responseData.serviceQuestionTOs,
            originalQuestion: responseData
          })
        }
      })
        .catch((error) => {
          console.log("err===", error);
        });
      }

      if((this.props.location.state.userData.serviceNumber == 1 || this.props.location.state.userData.serviceNumber == 3)
      &&(this.props.location.state.userData.spQuarterly == 'Yes')) {
      const url = apiConstants.servicequestions + id  + '&compartmentType=' + val + '/' + 'Filter Cleaning' + '/Notes' + "&page=" + pageno + "&rankNumber=" + rankNumber;
        API.authGetRequest(url, '')
          .then((res) => {
            if(res && res.data){
            const responseData = res.data;
            this.currentPageNumber = responseData.currentPage.mobilePageNumber;
            this.currentPageRankNumber = responseData.currentPage.rankNumber;
            this.previousPageNumber = responseData.previousPage.mobilePageNumber;
            this.previousPageRankNumber = responseData.previousPage.rankNumber;
            this.nextPageNumber = responseData.nextPage.mobilePageNumber;
            this.nextPageRankNumber = responseData.nextPage.rankNumber;
            const data =responseData.serviceQuestionTOs as Question[];
            if(data != null){
            if (data && data.length) {
              data.map((obj:Question) => {
                  // Dropdown hide logics based on the service type for property
                  if (obj.questionReference == 'info_trtmt_tank' || obj.questionReference == 'info_pump_tank' || obj.questionReference == 'info_peat_moss') {
  
                    const comparition = commonConstant.SERVICE_TYPE;
                    if (this.props?.location?.state?.userData?.serviceProgramType) {
                      const selectedCompination = this.props.location.state.userData.serviceProgramType.split('/');
                      if (selectedCompination.length) {
                        obj.hideElement = false;
                        selectedCompination.map((el: string) => {
                          if (comparition[el] == obj.questionReference) {
                            obj.hideElement = true;
                          }
                        });
                      }
                    }
                }
  
                if (obj.answerType === 'range' || obj.answerType == 'drain range') {
                  const str = obj.answerValue as string;
                  const label = obj.label as string;
                  obj.answer = obj.answer ? obj.answer : '0';
                  obj.answerValue = str.split('-').map(Number);
                  if (label) {
                    obj.label = label.split('-');
                  }
                } 
              })
            }
          }
            console.log("allService===", res);
            this.setState({
              headerTO: responseData.headerTO,
              data: responseData.serviceQuestionTOs,
              originalQuestion: responseData
            })
          }
        })
          .catch((error) => {
            console.log("err===", error);
          });
        }
  }

  goBack = ()=>{
    if(this.previousPageNumber != 0) {
      this.ServiceProgramCompartmentType(this.selectedData.id,this.previousPageNumber,this.previousPageRankNumber);

    } else {
      this.props.history.goBack();
    }
  }

  onChangeDrop(event: any, index : number)  {
    if (!event?.detail?.value) return;
    const updateEvent = this.state.data as Question[];
    const selectedQuestion = event?.target?.ariaLabel;
    const selectedAnswer = event?.detail?.value;
    if (selectedQuestion.indexOf('CONDITION OF TANK INTERIOR, ABOVE THE LIQUID') > -1 || selectedQuestion.indexOf('INLET BAFFLE') > -1){
      updateEvent.map((el: Question) => {

        if(el.questionReference === 'reason_for_unsatisfac' || el.questionReference === 'inlet_baffle_cond_fst_comp') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "Sat") {
          
          switch (el.questionReference) {
            case 'reason_for_sat_con':
            case 'unsat_re_tank':
            case 'unknown_re_tank':
            case 'Rea_For_unsatisfac':
            case 'fst_inlet_photo':
            case 'unkn_reas':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Sat with Concerns") {

          switch (el.questionReference) {
            case 'reason_for_sat_con':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'unknown_re_tank': 
            case 'unsat_re_tank':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unsat") {

          switch (el.questionReference) {
            case 'unsat_re_tank':
            case 'Rea_For_unsatisfac':
            case 'fst_inlet_photo':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'reason_for_sat_con': 
            case 'unknown_re_tank':
            case 'fst_inlet_photo':
            case 'unkn_reas': 
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unknown" || selectedAnswer === "Not Visible") {

          switch (el.questionReference) {
            case 'unknown_re_tank':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'reason_for_sat_con': 
            case 'unsat_re_tank':
            case 'Rea_For_unsatisfac':
            case 'fst_inlet_photo':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('OUTLET BAFFLE') > -1 || selectedQuestion.indexOf('INLET BAFFLE') > -1){

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'out_baffle_cond_fst_comp' || el.questionReference === 'inlet_baffle_cond_scnd_comp') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "Sat") {
          
          switch (el.questionReference) {
            case 'Re_fr_unsat':
            case 'fst_outlet_photo':
            case 'unkno_rea':
            case 'Rea_For_unsatisfac_scnd':
            case 'scnd_inlet_photo':
            case 'unkno_rea_fst':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unsat") {

          switch (el.questionReference) {
            case 'Re_fr_unsat':
            case 'fst_outlet_photo':
            case 'Rea_For_unsatisfac_scnd':
            case 'scnd_inlet_photo':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'unkno_rea': 
            case 'unkno_rea_fst':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Not Visible") {

          switch (el.questionReference) {
            case 'Re_fr_unsat': 
            case 'fst_outlet_photo':
            case 'Rea_For_unsatisfac_scnd':
            case 'scnd_inlet_photo':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('INTERIOR WALLS, ABOVE LIQUID') > -1 || selectedQuestion.indexOf('2ND COMP. INTERIOR WALLS, ABOVE LIQUID:') > -1){

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'cond_tank_interior_fst_comp' || el.questionReference === 'cond_tank_interior_scnd_comp') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "Sat") {
          
          switch (el.questionReference) {
            case 'fst_re_for_sat_con':
            case 'fst_unsat':
            case 'fst_int_wall_photo':
            case 'fst_unknown_rea':
            case 'sec_re_for_sat_con':
            case 'sec_unsat':
            case 'scnd_int_wall_photo':
            case 'sec_unknown_rea':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Sat with Concerns") {

          switch (el.questionReference) {
            case 'fst_re_for_sat_con':
            case 'sec_re_for_sat_con':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'fst_unsat':
            case 'fst_int_wall_photo':
            case 'fst_unknown_rea':
            case 'sec_unsat':
            case 'scnd_int_wall_photo':
            case 'sec_unknown_rea':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unsat") {

          switch (el.questionReference) {
            case 'fst_unsat':
            case 'fst_int_wall_photo':
            case 'sec_unsat':
            case 'scnd_int_wall_photo':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'fst_unknown_rea': 
            case 'fst_re_for_sat_con':
            case 'sec_unknown_rea':
            case 'sec_re_for_sat_con':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unknown") {

          switch (el.questionReference) {
            case 'fst_unknown_rea':
            case 'sec_unknown_rea':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'fst_re_for_sat_con': 
            case 'fst_unsat':
            case 'fst_int_wall_photo':
            case 'sec_re_for_sat_con':
            case 'sec_unsat':
            case 'scnd_int_wall_photo':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('DIVIDER WALL, ABOVE LIQUID') > -1 || selectedQuestion.indexOf('DIVIDER WALL (OTHER SIDE), ABOVE LIQUID:') > -1){

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'cond_div_wall_fst_comp' || el.questionReference === 'cond_div_wall_scnd_comp') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "Sat") {
          
          switch (el.questionReference) {
            case 'fst_re_dat_div':
            case 'fst_unsat_div':
            case 'fst_div_wall_photo':
            case 'fst_unknown_rea_div':
            case 'sec_re_dat_div':
            case 'sec_unsat_div':
            case 'scnd_div_wall_photo':
            case 'sec_unknown_rea_div':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Sat with Concerns") {

          switch (el.questionReference) {
            case 'fst_re_dat_div':
            case 'sec_re_dat_div':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'fst_unsat_div':
            case 'fst_div_wall_photo':
            case 'fst_unknown_rea_div':
            case 'sec_unsat_div':
            case 'scnd_div_wall_photo':
            case 'sec_unknown_rea_div':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unsat") {

          switch (el.questionReference) {
            case 'fst_unsat_div':
            case 'fst_div_wall_photo':
            case 'sec_unsat_div':
            case 'scnd_div_wall_photo':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'fst_unknown_rea_div': 
            case 'fst_re_dat_div':
            case 'sec_unknown_rea_div':
            case 'sec_re_dat_div':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unknown") {

          switch (el.questionReference) {
            case 'fst_unknown_rea_div':
            case 'sec_unknown_rea_div':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'fst_re_dat_div': 
            case 'fst_unsat_div':
            case 'fst_div_wall_photo':
            case 'sec_re_dat_div':
            case 'sec_unsat_div':
            case 'scnd_div_wall_photo':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('INTERIOR WALLS, ABOVE THE LIQUID')>-1){

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'cond_int_walls') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "Sat") {
          
          switch (el.questionReference) {
            case 'sat_reason':
            case 'un_reas':
            case 'unknown_rea':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unsat") {

          switch (el.questionReference) {
            case 'un_reas':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'unknown_rea':
            case 'sat_reason':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unknown") {

          switch (el.questionReference) {
            case 'unknown_rea':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'sat_reason':
            case 'un_reas':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Sat with Concerns") {
            switch(el.questionReference) {
              case 'un_reas':
              case 'unknown_rea':
                el.disableFlag = true;
                el.hideElement = false;
                break;
              case 'sat_reason':
                el.disableFlag = false;
                el.hideElement = true;
            }
        }
      });

      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('OUTLET (DISCHARGE) PIPE') > -1 || selectedQuestion.indexOf('INLET BAFFLE')>-1){

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'pump_out_baf' || el.questionReference === 'inlet_baf_cond') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "Sat") {
          
          switch (el.questionReference) {
            case 'pump_out_unsat':
            case 'pump_out_photo':
            case 'pump_out_unknown':
            case 'un_reason':
            case 'pump_in_photo':
            case 'pump_in_unknown':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unsat") {

          switch (el.questionReference) {
            case 'pump_out_unsat':
            case 'pump_out_photo':
            case 'un_reason':
            case 'pump_in_photo':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'pump_out_unknown': 
            case 'pump_in_unknown':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Not Visible") {

          switch (el.questionReference) {
            case 'pump_out_unsat':
            case 'pump_out_photo':
            case 'un_reason':
            case 'pump_in_photo':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('OUTLET BAFFLE')>-1){

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'out_baffle_cond_scnd_comp') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "Sat") {
          
          switch (el.questionReference) {
            case 'Re_fr_unsat_scnd':
            case 'scnd_outlet_photo':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unsat") {

          switch (el.questionReference) {
            case 'Re_fr_unsat_scnd':
            case 'scnd_outlet_photo':
              el.disableFlag = false;
              el.hideElement = true;
              break;
          }
        } else if (selectedAnswer === "Not Visible") {

          switch (el.questionReference) {
            case 'Re_fr_unsat_scnd':
            case 'scnd_outlet_photo':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
    }
    this.serviceQuestionUpdate(event.detail.value,index);
  }

  onChangeMultiDrop(event: any, index : number)  {
    const val = event.detail.value;
    const finval = val.toString();
    const updatedData = {...this.state.data};
    if(updatedData && updatedData.length && 
      updatedData.length > index && updatedData[index].answer) {
      updatedData[index].answer = event;

    this.setState({
      data : updatedData
    })
      console.log(event);
    }

    // this.serviceQuestionUpdate(event,index);
    this.serviceQuestionUpdate(finval,index);
  }

  radioOnchange = (event: any, index : number) => {
    
    if (!event?.detail?.value) return;
    const updateEvent = this.state.data as Question[];
    const selectedQuestion = event?.target?.innerText;
    const selectedAnswer = event?.detail?.value;

    if (selectedQuestion.indexOf('GROUND SURFACE, OVER THE SEPTIC TANK') > -1 || selectedQuestion.indexOf('OUTLET BAFFLE') > -1) {

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'cond_gro_sur_tank1' || el.questionReference === 'out_baffle_cond_tank1') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "Sat") {
          
          switch (el.questionReference) {
            case 're_unsa':
            case 'gro_surf_photo':
            case 're_forr_unsat':
            case 'unknown_rea_outlet':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unsat") {

          switch (el.questionReference) {
            case 're_unsa':
            case 'gro_surf_photo':
            case 're_forr_unsat':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'unknown_rea_outlet':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Not Visible") {
          switch (el.questionReference) {
            case 're_forr_unsat':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('MAIN ACCESS LID') > -1 || (selectedQuestion.indexOf('UNUSUAL OBJECTS / MATTER COLLECTED') > -1 && this.state.data[index].compartmentType != 'Filter Cleaning')) {

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'cond_sep_tank1_lid' || el.questionReference === 'obj_mat_collec') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "Sat" || selectedAnswer === "No") {
          
          switch (el.questionReference) {
            case 'unsatisfac_re_sep':
            case 'acc_lid_photo':
            case 'wht_was_fnd':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unsat" || selectedAnswer === "Yes") {

          switch (el.questionReference) {
            case 'unsatisfac_re_sep':
            case 'acc_lid_photo':
            case 'wht_was_fnd':
              el.disableFlag = false;
              el.hideElement = true;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('UNUSUAL OBJECTS / MATTER COLLECTED') > -1 && this.state.data[index].compartmentType == 'Filter Cleaning') {

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'obj_mat_collec') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "No") {
          
          switch (el.questionReference) {
            case 'wht_was_fnd':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Yes") {

          switch (el.questionReference) {
            case 'wht_was_fnd':
              el.disableFlag = false;
              el.hideElement = true;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('IS THE DRAIN FIELD OVERGROWN WITH VEGETATION') > -1 || selectedQuestion.indexOf('GROUND SURFACE, OVER SEPTIC TANK') > -1) {

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'drain_fie_vege' || el.questionReference === 'drain_fie_vege_scnd' || el.questionReference === 'cond_gro_sur_tank2') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "No" || selectedAnswer == "no" || selectedAnswer === "Sat") {
          
          switch (el.questionReference) {
            case 'drain_fie_photo':
            case 'drain_fie_photo_scnd':
            case 'Reason_unsa':
            case 'fst_gro_surf_photo':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Yes" || selectedAnswer == "yes" || selectedAnswer === "Unsat") {

          switch (el.questionReference) {
            case 'drain_fie_photo':
            case 'drain_fie_photo_scnd':
            case 'Reason_unsa':
            case 'fst_gro_surf_photo':
              el.disableFlag = false;
              el.hideElement = true;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('INLET BAFFLE') > -1 || selectedQuestion.indexOf('LID') > -1) {

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'inlet_baffle_cond_tank1' || el.questionReference === 'cond_scnd_comp_lid') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "Sat") {
          
          switch (el.questionReference) {
            case 'rea_for_unsatisfactory':
            case 'inlet_photo':
            case 'unknown_rea_inlet':
            case 'unsatisfac_rea_sep_scnd':
            case 'scnd_acc_lid_photo':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unsat") {

          switch (el.questionReference) {
            case 'rea_for_unsatisfactory':
            case 'inlet_photo':
            case 'unsatisfac_rea_sep_scnd':
            case 'scnd_acc_lid_photo':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'unknown_rea_inlet':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Not Visible") {
          switch (el.questionReference) {
            case 'rea_for_unsatisfactory':
            case 'inlet_photo':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('LID') > -1 || selectedQuestion.indexOf('CONDITION OF GROUND, OVER THE TANK') >-1) {

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'cond_fst_comp_lid' || el.questionReference === 'cond_gro_surf') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "Sat") {
          
          switch (el.questionReference) {
            case 'unsatisfac_rea_sep_fst':
            case 'fst_acc_lid_photo':
            case 'unsatisfac_reason':
            case 'h600_gro_sur_pho':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unsat") {

          switch (el.questionReference) {
            case 'unsatisfac_rea_sep_fst':
            case 'fst_acc_lid_photo':
            case 'unsatisfac_reason':
            case 'h600_gro_sur_pho':
              el.disableFlag = false;
              el.hideElement = true;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('RISER') > -1 || selectedQuestion.indexOf('UNUSUAL OBJECTS / MATTER COLLECTED') > -1) {

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'cond_fst_comp_riser' || el.questionReference === 'obj_mat_colle_scnd') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "Sat" || selectedAnswer === "No") {
          
          switch (el.questionReference) {
            case 'Unsatis_rea_sep':
            case 'fst_riser_photo':
            case 'wht_was_fnd_scnd':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unsat" || selectedAnswer === "Yes") {

          switch (el.questionReference) {
            case 'Unsatis_rea_sep':
            case 'fst_riser_photo':
            case 'wht_was_fnd_scnd':
              el.disableFlag = false;
              el.hideElement = true;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('WHEN THE PUMP FLOAT WAS LIFTED, DID THE PUMP ACTIVATE') > -1 || selectedQuestion.indexOf('GROUND SURFACE, OVER THE PUMP VESSEL') >-1) {

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'pump_activate' || el.questionReference === 'cond_gro_sur') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "No" || selectedAnswer === 'Unsat') {
          
          switch (el.questionReference) {
            case 'follow_up_needed':
            case 'unsatis_reason':
            case 'pump_gro_sur_pho':
            case 'pump_control_panel':
              el.disableFlag = false;
              el.hideElement = true;
              break;
          }
        } else if (selectedAnswer === "Yes" || selectedAnswer === 'Sat') {

          switch (el.questionReference) {
            case 'follow_up_needed':
            case 'unsatis_reason':
            case 'pump_gro_sur_pho':
            case 'pump_control_panel':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
    }
    if (selectedQuestion.indexOf('MAIN ACCESS LID') > -1 || selectedQuestion.indexOf('IS THE PUMP LIFTED OFF ITS PEDESTAL') >-1) {

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'cond_main_acc_lid' || el.questionReference === 'pump_fully_pedestal') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "Sat" || selectedAnswer === 'No') {
          
          switch (el.questionReference) {
            case 'rea_for_unsatis':
            case 'pump_main_lid_pho':
            case 'pump_pedes_foll_up':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unsat" || selectedAnswer === "Yes") {

          switch (el.questionReference) {
            case 'rea_for_unsatis':
            case 'pump_main_lid_pho':
            case 'pump_pedes_foll_up':
              el.disableFlag = false;
              el.hideElement = true;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
      
    }
    if (selectedQuestion.indexOf('RISER') > -1 || selectedQuestion.indexOf('ACCUMULATION OF SEWAGE AROUND THE BASE OF PUMP') >-1) {

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'cond_of_riser' || el.questionReference === 'sew_aro_base_pump') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "Sat" || selectedAnswer === 'No') {
          
          switch (el.questionReference) {
            case 'reason_unsatisfactory':
            case 'pump_riser_pho':
            case 'pump_necessary':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unsat" || selectedAnswer === "Yes") {

          switch (el.questionReference) {
            case 'reason_unsatisfactory':
            case 'pump_riser_pho':
            case 'pump_necessary':
              el.disableFlag = false;
              el.hideElement = true;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
    }
      if (selectedQuestion.indexOf('ELECTRICAL JUNCTION BOX') > -1 || selectedQuestion.indexOf('ARE FLOATS SECURED PROPERLY') >-1
      || selectedQuestion.indexOf('MODE 4, ALARM(S) SOUNDED') > -1) {

        updateEvent.map((el: Question) => {
  
          if(el.questionReference === 'prob_with_junc_box' || el.questionReference === 'float_secured' || el.questionReference == 'alarm_sound') {
              el.answer = selectedAnswer;
            }
  
          if (selectedAnswer === "Sat" || selectedAnswer == 'No') {
            
            switch (el.questionReference) {
              case 'if_yes_what':
              case 'fol_up_jun_box':
              case 'if_no':
              case 'alarm_code':
                el.disableFlag = true;
                el.hideElement = false;
                break;
            }
          } else if (selectedAnswer === "Unsat" || selectedAnswer == 'Yes') {
  
            switch (el.questionReference) {
              case 'if_yes_what':
              case 'fol_up_jun_box':
              case 'if_no':
              case 'alarm_code':
                el.disableFlag = false;
                el.hideElement = true;
                break;
            }
          }
        });
  
        this.setState({
          data: updateEvent
        });
    }
    if (selectedQuestion.indexOf('SEPTIC LIQUID LEVEL') > -1 || selectedQuestion.indexOf('IS SEWAGE BREAKING OUT ONTO THE GROUND SURFACE') >-1) {

      updateEvent.map((el: Question) => {

        if(el.questionReference === 'sep_liq_lvl_tank1' || el.questionReference === 'sew_breaking' || el.questionReference == 'sew_breaking_scnd') {
            el.answer = selectedAnswer;
          }

        if (selectedAnswer === "Sat" || selectedAnswer === "No" || selectedAnswer == 'no') {
          
          switch (el.questionReference) {
            case 'unsat_rea_liq_lvl':
            case 'sew_break_photo':
            case 'sew_break_photo_scnd':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        } else if (selectedAnswer === "Unsat" || selectedAnswer === "Yes" || selectedAnswer == 'yes') {

          switch (el.questionReference) {
            case 'unsat_rea_liq_lvl':
            case 'sew_break_photo':
            case 'sew_break_photo_scnd':
              el.disableFlag = false;
              el.hideElement = true;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
      
  }
  if (selectedQuestion.indexOf('SEPTIC LIQUID LEVEL') > -1 || selectedQuestion.indexOf('LARGE OR HEAVY OBJECTS OVER THE DRAINAGE FIELD?') >-1) {

    updateEvent.map((el: Question) => {

      if(el.questionReference === 'sep_liq_lvl_scnd_comp' || el.questionReference === 'large_heavy_obj' || el.questionReference === 'large_heavy_obj_scnd') {
          el.answer = selectedAnswer;
        }

      if (selectedAnswer === "Sat" || selectedAnswer === "No" || selectedAnswer == "no" ) {
        
        switch (el.questionReference) {
          case 'unsat_rea_liq_lvl':
          case 'heavy_obj_photo':
          case 'heavy_obj_photo_scnd':
            el.disableFlag = true;
            el.hideElement = false;
            break;
        }
      } else if (selectedAnswer === "Unsat" || selectedAnswer === "Yes" || selectedAnswer == 'yes') {

        switch (el.questionReference) {
          case 'unsat_rea_liq_lvl':
          case 'heavy_obj_photo':
          case 'heavy_obj_photo_scnd':
            el.disableFlag = false;
            el.hideElement = true;
            break;
        }
      }
    });

    this.setState({
      data: updateEvent
    });
    
}
if (selectedQuestion.indexOf('RISER') > -1 || selectedQuestion.indexOf('IS THE DRAINAGE FIELD OVERGROWN')>-1) {

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'cond_sep_riser_tank1' || el.questionReference === 'drain_over_grown_scnd' ) {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "Sat" || selectedAnswer === 'No') {
      
      switch (el.questionReference) {
        case 'unsat_rea_septic':
        case 'riser_photo':
        case 'drain_fie_dou_pho':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Unsat" || selectedAnswer === 'Yes' ) {

      switch (el.questionReference) {
        case 'unsat_rea_septic':
        case 'riser_photo':
        case 'drain_fie_dou_pho':
          el.disableFlag = false;
          el.hideElement = true;
          break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
  
}
if (selectedQuestion.indexOf('IS SEWAGE BREAKING OUT ONTO THE GROUND SURFACE') > -1 || selectedQuestion.indexOf('SEPTIC LIQUID LEVEL')>-1) {

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'sew_breaking_scnd' || el.questionReference === 'liq_level' ) {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "No" || selectedAnswer === 'Sat') {
      
      switch (el.questionReference) {
        case 'sew_brk_dou_pho':
        case 'unsat_rea_liq_lvl':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Yes" || selectedAnswer === 'Unsat' ) {

      switch (el.questionReference) {
        case 'sew_brk_dou_pho':
        case 'unsat_rea_liq_lvl':
          el.disableFlag = false;
          el.hideElement = true;
          break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
  
}
if (selectedQuestion.indexOf('LARGE OR HEAVY OBJECTS OVER THE DRAINAGE FIELD?') > -1 || selectedQuestion.indexOf('CONDITION OF AREA OVER THE MODULE') > -1) {

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'large_heavy_obj_scnd' || el.questionReference === 'cond_of_gro_sur' ) {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "No" || selectedAnswer === "Sat") {
      
      switch (el.questionReference) {
        case 'lar_obj_dou_pho':
        case 'unsat_gro_surf':
        case 'peat_poly_gro_sur_pho':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Yes" || selectedAnswer === "Unsat" ) {

      switch (el.questionReference) {
        case 'lar_obj_dou_pho':
        case 'unsat_gro_surf':
        case 'peat_poly_gro_sur_pho':
          el.disableFlag = false;
          el.hideElement = true;
          break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
  
}
if (selectedQuestion.indexOf('CONDITION OF ACCESS LID') > -1 || selectedQuestion.indexOf('VENT PIPES') > -1) {

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'main_lid_exposed' || el.questionReference === 'pipe_prop_sec' ) {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "Sat") {
      
      switch (el.questionReference) {
        case 'reason_for_unsat':
        case 'peat_poly_acc_lid_pho':
        case 're_un_sa':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Unsat") {

      switch (el.questionReference) {
        case 'reason_for_unsat':
        case 'peat_poly_acc_lid_pho':
        case 're_un_sa':
          el.disableFlag = false;
          el.hideElement = true;
          break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
  
}
if (selectedQuestion.indexOf('INSIDE THE MODULE, WHAT IS THE CONDITION OF THE TOP') > -1 || selectedQuestion.indexOf('DISTRIBUTION PLATE') > -1) {

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'cond_of_the_top' || el.questionReference === 'dis_plate_ok' ) {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "Sat") {
      
      switch (el.questionReference) {
        case 'prob_noted':
        case 'reas_un_sa':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Unsat") {

      switch (el.questionReference) {
        case 'prob_noted':
        case 'reas_un_sa':
          el.disableFlag = false;
          el.hideElement = true;
          break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
  
}
if (selectedQuestion.indexOf('CONDTION OF PEATMOSS') > -1 || selectedQuestion.indexOf('CONDITION OF TANK') > -1) {

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'good_condition' || el.questionReference === 'peat_tank' ) {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "Sat") {
      
      switch (el.questionReference) {
        case 'what_problem_noted':
        case 'peat_tank_unsat':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Unsat") {

      switch (el.questionReference) {
        case 'what_problem_noted':
        case 'peat_tank_unsat':
          el.disableFlag = false;
          el.hideElement = true;
          break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
  
}
if (selectedQuestion.indexOf('DID THE FINAL EFFLUENT HAVE ANY BAD ODOR?') > -1 || selectedQuestion.indexOf('2ND COMPARTMENT RISER (UNDER MAIN LID') >-1) {

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'eff_bad_odor' || el.questionReference === 'cond_scnd_comp_riser') {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "No" || selectedAnswer === "Satisfactory") {
      
      switch (el.questionReference) {
        case 'Unsat_rea_sep_scnd':
        case 'scnd_riser_photo':
        case 'fo_up_need':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Yes" || selectedAnswer === "Unsatisfactory") {

      switch (el.questionReference) {
        case 'fo_up_need':
        case 'Unsat_rea_sep_scnd':
        case 'scnd_riser_photo':
          el.disableFlag = false;
          el.hideElement = true;
          break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
}
if (selectedQuestion.indexOf('LID CONDITION') > -1 || selectedQuestion.indexOf('CONTROL PANEL: MODE 1,PROBE/FLOATS:OPERATIONAL') >-1) {

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'lid_condi' || el.questionReference === 'prob_dloat') {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "Sat" || selectedAnswer === "Yes") {
      
      switch (el.questionReference) {
        case 'rea_unsatisfac':
        case 'mode1_fol_up':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Unsat" || selectedAnswer === "No") {

      switch (el.questionReference) {
        case 'rea_unsatisfac':
        case 'mode1_fol_up':
          el.disableFlag = false;
          el.hideElement = true;
          break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
}
if (selectedQuestion.indexOf('RISER CONDITION') > -1 || selectedQuestion.indexOf('CONDITION OF TRASH COMPARTMENT OUTLET BAFFLE') >-1) {

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'ris_con' || el.questionReference === 'out_baf_cond') {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "Sat") {
      
      switch (el.questionReference) {
        case 'unsatis_reasons':
        case 'out_rea_unsatis':
        case 'h600_out_pho':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Unsat") {

      switch (el.questionReference) {
        case 'unsatis_reasons':
        case 'out_rea_unsatis':
        case 'h600_out_pho':
          el.disableFlag = false;
          el.hideElement = true;
          break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
}
if (selectedQuestion.indexOf('CONDITION OF RISER') > -1 || selectedQuestion.indexOf('CONDITION OF OUTLET BAFFLE IN AERATION COMPARTMENT') >-1) {

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'ris_cond_comp' || el.questionReference === 'cond_out_baffle_comp2') {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "Sat") {
      
      switch (el.questionReference) {
        case 'unsat_re':
        case 'out_rea_unsatis':
        case 'h600_aero_pho':
        case 'unsat_rea_comp2':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Unsat") {

      switch (el.questionReference) {
        case 'unsat_re':
        case 'out_rea_unsatis':
        case 'h600_aero_pho':
        case 'unsat_rea_comp2':
          el.disableFlag = false;
          el.hideElement = true;
          break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
}
if (selectedQuestion.indexOf('CONDITION OF AERATORS DOG HOUSE') > -1 || selectedQuestion.indexOf('CONDITION OF TRASH COMPARTMENT INLET BAFFLE') >-1) {

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'cond_aer' || el.questionReference === 'in_baf_cond') {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "Sat") {
      
      switch (el.questionReference) {
        case 'what_prob_there':
        case 'h600_aerator_pho':
        case 'in_rea_unsatis':
        case 'h600_inlet_pho':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Unsat") {

      switch (el.questionReference) {
        case 'what_prob_there':
        case 'h600_aerator_pho':
        case 'in_rea_unsatis':
        case 'h600_inlet_pho':
          el.disableFlag = false;
          el.hideElement = true;
          break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
}
if (selectedQuestion.indexOf('CONDITION OF CONDUITS') > -1 || selectedQuestion.indexOf('MODE 2, PUMP: OPERATIONAL') >-1) {

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'cond_of_conduits' || el.questionReference === 'pump_oper') {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "Sat" || selectedAnswer === "Yes") {
      
      switch (el.questionReference) {
        case 'rea_unsat_conduit':
        case 'mode2_fol_up':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Unsat" || selectedAnswer === "No") {

      switch (el.questionReference) {
        case 'rea_unsat_conduit':
        case 'mode2_fol_up':
          el.disableFlag = false;
          el.hideElement = true;
          break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
}
if (selectedQuestion.indexOf('CONDITION OF AIRLINE SENSOR') > -1 || selectedQuestion.indexOf('MODE 3, AERATOR: OPERATIONAL') >-1) {

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'cond_of_air_sensor' || el.questionReference === 'aere_oper') {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "Sat" || selectedAnswer === "Yes") {
      
      switch (el.questionReference) {
        case 'rea_unsat_air_sensor':
        case 'mode3_fol_up':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Unsat" || selectedAnswer === "No") {

      switch (el.questionReference) {
        case 'rea_unsat_air_sensor':
        case 'mode3_fol_up':
          el.disableFlag = false;
          el.hideElement = true;
          break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
}
if (selectedQuestion.indexOf('MODE 4, ALARM(S) SOUNDED') > -1 || selectedQuestion.indexOf('AEROBIC COMPARTMENT LID CONDITION')>-1) {

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'alarm_sound' || el.questionReference === 'aer_lid_cond') {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "No" || selectedAnswer === "Sat") {
      
      switch (el.questionReference) {
        case 'mode4_fol_up':
        case 'aero_lid_unsat':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Yes" || selectedAnswer === "Unsat") {

      switch (el.questionReference) {
        case 'mode4_fol_up':
        case 'aero_lid_unsat':
          el.disableFlag = false;
          el.hideElement = true;
          break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
}
if (selectedQuestion.indexOf('INSPECTION PORT(S)') > -1 || selectedQuestion.indexOf('RISER') >-1){

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'ins_port' || el.questionReference == 'cond_scnd_comp_riser') {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "Sat") {
      
      switch (el.questionReference) {
        case 'ins_port_reason':
        case 'ins_port_size':
        case 'Unsat_rea_sep_scnd':
        case 'scnd_riser_photo':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Unsat") {

      switch (el.questionReference) {
        case 'ins_port_reason':
        case 'ins_port_size':
        case 'Unsat_rea_sep_scnd':
        case 'scnd_riser_photo':
          el.disableFlag = false;
          el.hideElement = true;
          break;
        case 'pump_out_unknown': 
        case 'pump_in_unknown':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
}
if (selectedQuestion.indexOf('LIQUID') > -1 || selectedQuestion.indexOf('Landmarks near tank(s)')>-1 || selectedQuestion.indexOf('IS PUMP CONTROLLED WITH A TIME DOSE PANEL') > -1){

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'drain_liquid' || el.questionReference == 'landmark_near_tank' || el.questionReference == 'pump_control_panel') {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "Sat" || selectedAnswer == 'No') {
      
      switch (el.questionReference) {
        case 'fol_need_sat_con':
        case 'fol_need_unsat':
        case 'landmark_options':
        case 'pho_land':
        case 'pump_control_no_fol_up':
          el.disableFlag = true;
          el.hideElement = false;
          break;
        case 'fol_up':
          el.disableFlag = false;
          el.hideElement = true;
          break;
      }
    } else if (selectedAnswer === "Sat with Concerns" || selectedAnswer == "Yes") {

      switch (el.questionReference) {
        case 'fol_need_sat_con':
        case 'landmark_options':
        case 'pho_land':
        case 'pump_control_no_fol_up':
          el.disableFlag = false;
          el.hideElement = true;
          break;
        case 'fol_need_unsat':
        case 'fol_up':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Unsat") {

      switch (el.questionReference) {
        case 'fol_need_unsat':
          el.disableFlag = false;
          el.hideElement = true;
          break;
        case 'fol_need_sat_con':
          el.disableFlag = true;
          el.hideElement = false;
            break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
}
if (selectedQuestion.indexOf('CORNER PORTS,AT GRADE') > -1 || selectedQuestion.indexOf('CONDITION OF EFFLUENT FILTER') > -1){
updateEvent.map((el: Question) => {
if(el.questionReference == 'corner_ports_drain_field' || el.questionReference == 'corner_ports_drain_field_scnd' || el.questionReference == 'cond_of_eff_filter') {
  el.answer = selectedAnswer;
}
if (selectedAnswer == "Yes" || selectedAnswer == "yes" || selectedAnswer == "Unsat") {
  switch (el.questionReference) {
    case 'no_of_corner_ports':
    case 'water_ins_port':
    case 'no_of_corner_ports_scnd':
    case 'water_ins_port_scnd':
    case 'ins_port':
    case 'ins_port_scnd':
    case 'port_measurement':
    case 'scnd_port_measurement':
    case 'fol_up_needed':
    case 'fol_up_needed_scnd':
    case 'eff_filter_unsat_reason':
      el.disableFlag = false;
      el.hideElement = true;
      break;
  }
} else  if (selectedAnswer == "No" || selectedAnswer == "no" || selectedAnswer == "Sat") {
switch (el.questionReference) {
    case 'no_of_corner_ports':
    case 'water_ins_port':
    case 'no_of_corner_ports_scnd':
    case 'water_ins_port_scnd':
    case 'ins_port':
    case 'ins_port_scnd':
    case 'port_measurement':
    case 'scnd_port_measurement':
    case 'fol_up_needed':
    case 'fol_up_needed_scnd':
    case 'eff_filter_unsat_reason':
     el.disableFlag = true;
     break;
}
}
});
this.setState({
data: updateEvent
});
}
if (selectedQuestion.indexOf('DEEP PORT AT GRADE') > -1 ){
  updateEvent.map((el: Question) => {
     if(el.questionReference == 'port_at_grade' || el.questionReference == 'port_at_grade_scnd') {
       el.answer = selectedAnswer;
     }
     if (selectedAnswer == 'Yes' || selectedAnswer == 'yes') {
       switch (el.questionReference) {
        case 'water_ins_deep_port':
        case 'water_ins_deep_port_scnd':
        case 'deep_port_measurement':
        case 'scnd_deep_port_measurement':
           el.disableFlag = false;
           break;
       }
   } else  if (selectedAnswer == 'No' || selectedAnswer == 'no') {
     switch (el.questionReference) {
        case 'water_ins_deep_port':
        case 'water_ins_deep_port_scnd':
        case 'deep_port_measurement':
        case 'scnd_deep_port_measurement':
         el.disableFlag = true;
         break;
   }
 }
 });
 this.setState({
   data: updateEvent
 });
}
if (selectedQuestion.indexOf('MEASURABLE WATER INSIDE PORT') > -1 ){
  updateEvent.map((el: Question) => {
     if(el.questionReference == 'water_ins_port' || el.questionReference == 'water_ins_port_scnd') {
       el.answer = selectedAnswer;
     }
     if (selectedAnswer == 'Yes' || selectedAnswer == 'yes') {
       switch (el.questionReference) {
        case 'port_measurement':
        case 'scnd_port_measurement':
           el.disableFlag = false;
           el.hideElement = true;
           break;
       }
   } else if (selectedAnswer == 'No' || selectedAnswer == 'no') {
     switch (el.questionReference) {
        case 'port_measurement':
        case 'scnd_port_measurement':
         el.disableFlag = true;
         el.hideElement = false;
         break;
   }
 }
 });
 this.setState({
   data: updateEvent
 });
}
if (selectedQuestion.indexOf('MEASURABLE WATER INSIDE DEEP PORT') > -1 ){
  updateEvent.map((el: Question) => {
     if(el.questionReference == 'water_ins_deep_port' || el.questionReference == 'water_ins_deep_port_scnd') {
       el.answer = selectedAnswer;
     }
     if (selectedAnswer == 'Yes' || selectedAnswer == 'yes') {
       switch (el.questionReference) {
        case 'deep_port_measurement':
        case 'scnd_deep_port_measurement':
           el.disableFlag = false;
           el.hideElement = true;
           break;
       }
   } else if (selectedAnswer == 'No' || selectedAnswer == 'no') {
     switch (el.questionReference) {
        case 'deep_port_measurement':
        case 'scnd_deep_port_measurement':
         el.disableFlag = true;
         el.hideElement = false;
         break;
   }
 }
 });
 this.setState({
   data: updateEvent
 });
}
if (selectedQuestion.indexOf('INSPECTION PORT(S)') > -1 ){

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'ins_port_scnd') {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "Sat") {
      
      switch (el.questionReference) {
        case 'ins_port_reason_scnd':
        case 'ins_port_size_scnd':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Unsat") {

      switch (el.questionReference) {
        case 'ins_port_reason_scnd':
        case 'ins_port_size_scnd':
          el.disableFlag = false;
          el.hideElement = true;
          break;
        case 'pump_out_unknown': 
        case 'pump_in_unknown':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
}
if (selectedQuestion.indexOf('LIQUID') > -1){

  updateEvent.map((el: Question) => {

    if(el.questionReference === 'drain_liquid_scnd') {
        el.answer = selectedAnswer;
      }

    if (selectedAnswer === "Sat") {
      
      switch (el.questionReference) {
        case 'fol_need_sat_con_scnd':
        case 'fol_need_unsat_scnd':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Sat with Concerns") {

      switch (el.questionReference) {
        case 'fol_need_sat_con_scnd':
          el.disableFlag = false;
          el.hideElement = true;
          break;
        case 'fol_need_unsat_scnd':
          el.disableFlag = true;
          el.hideElement = false;
          break;
      }
    } else if (selectedAnswer === "Unsat") {

      switch (el.questionReference) {
        case 'fol_need_unsat_scnd':
          el.disableFlag = false;
          el.hideElement = true;
          break;
        case 'fol_need_sat_con_scnd':
          el.disableFlag = true;
          el.hideElement = false;
            break;
      }
    }
  });

  this.setState({
    data: updateEvent
  });
}
    this.serviceQuestionUpdate(event.detail.value,index);
  }

  OnChangeRadio =(event : any,id : number,index : number,pageno : number, rankNumber : number) => {
    //To display questions based on radiobutton values choosen
    const val = event.detail.value;
    console.log("radio value",val);
    const nextpage = this.nextPageNumber + 4;
    const nextpageRankNumber = this.nextPageRankNumber + 4;
    
    if(val == 1 && this.state.headerTO.serviceProgramType.includes('(Second)')){
      this.ServiceProgramCompartmentType(this.selectedData.id,nextpage,nextpageRankNumber)
    } else if(val == 1 && this.state.headerTO.title == 'DRAINAGE FIELD'){
      this.ServiceProgramCompartmentType(this.selectedData.id,this.nextPageNumber + 6,this.nextPageRankNumber + 6)
    } else if(val == 1 && this.state.headerTO.title == 'DRAINAGE FIELD (SECOND)'){
      this.ServiceProgramCompartmentType(this.selectedData.id,this.nextPageNumber + 8,this.nextPageRankNumber + 8)
    } else if(val == 2 && !this.state.headerTO.serviceProgramType.includes('(Second)')){
      this.ServiceProgramCompartmentType(this.selectedData.id,this.nextPageNumber,this.nextPageRankNumber)
    } else if(val == 2 && this.state.headerTO.serviceProgramType.includes('(Second)')){
      this.ServiceProgramCompartmentType(this.selectedData.id,this.nextPageNumber,this.nextPageRankNumber)
    } else if(val == 'Diverter Valve' && this.state.headerTO.serviceProgramType.includes('(Second)')){
      this.ServiceProgramCompartmentType(this.selectedData.id,this.nextPageNumber,this.nextPageRankNumber)
    } else if(val == 'Diverter Valve' && this.state.headerTO.title == 'DRAINAGE FIELD'){
      this.ServiceProgramCompartmentType(this.selectedData.id,this.nextPageNumber,this.nextPageRankNumber)
    } else if(val == 'D-Box' && this.state.headerTO.serviceProgramType.includes('(Second)')){
      this.ServiceProgramCompartmentType(this.selectedData.id,this.nextPageNumber,this.nextPageRankNumber)
    } else if(val == 'D-Box' && this.state.headerTO.title == 'DRAINAGE FIELD'){
      this.ServiceProgramCompartmentType(this.selectedData.id,this.nextPageNumber,this.nextPageRankNumber)
    } else if(val == 'D-Box' && this.state.headerTO.title == 'DRAINAGE FIELD (SECOND)'){
      this.ServiceProgramCompartmentType(this.selectedData.id, this.nextPageNumber + 3,this.nextPageRankNumber + 3)
    }
    this.serviceQuestionUpdate(event.detail.value,index);
    this.getServiceProgramDetails();
  }

  rangeUpdate(event : any, index: number) {
    const updatedData = {...this.state};
    if(updatedData && updatedData.data && updatedData.data.length && 
      updatedData.data.length > index && updatedData.data[index].answer) {
      updatedData.data[index].answer = event;

    this.setState({
      data : updatedData.data
    })
      console.log(event);

    const updateEvent = this.state.data as Question[];
    const selectedAnswer = event;

    if (updatedData.data[index].mobileView.indexOf('HOW MANY INCHES') > -1) {

      updateEvent.map((el: Question) => {

        if (el.questionReference === 'port_measurement' || el.questionReference == 'scnd_port_measurement') {
          el.answer = selectedAnswer;
        }

        if (event > 6) {

          switch (el.questionReference) {
            case 'fol_up_needed':
            case 'fol_up_needed_scnd':
              el.disableFlag = false;
              el.hideElement = true;
              break;
          }
        } else {

          switch (el.questionReference) {
            case 'fol_up_needed':
            case 'fol_up_needed_scnd':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
        }
      });

      this.setState({
        data: updateEvent
      });
     }
    }

    this.serviceQuestionUpdate(event,index);
}

textOnchange(event: any,index: number) {
  this.serviceQuestionUpdate(event,index);
}

serviceQuestionUpdate(event:any,index:number){
    const updatedData = {...this.state.originalQuestion};
    if(updatedData && updatedData.serviceQuestionTOs.length > index  &&  updatedData.serviceQuestionTOs[index]) {
      updatedData.serviceQuestionTOs[index].answer = event;
      this.setState({
        originalQuestion: updatedData
      });
      console.log(event);
    }
  }

  ionViewWillEnter() {
    console.log('ionViewWillEnter event fired')
  }

  ionViewWillLeave() {
    console.log('ionViewWillLeave event fired')
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter event fired')
  }

  ionViewDidLeave() {
    console.log('ionViewDidLeave event fired')
  }

  async takePhoto(index:number) {
   
    const formdata = CAMERA();
    this.uploadImage(await formdata,this.selectedData.id,index);
  }

  // Upload Captured Image
   uploadImage(formData:FormData, id : number,index : number) {
    const customerId = this.props.location.state.userData.customerId;
    const townshipId = this.props.location.state.userData.townshipId;
    const compartmentType = this.state.data[index].compartmentType;
    const questionReference = this.state.data[index].questionReference;
    const type = "sp";
    const uploadRequest = API.authPostRequest(apiConstants.photoUploadUrl + id  + '&type=' + type  + '&customerId=' +
    + customerId + '&townshipId=' + townshipId + '&compartment=' + compartmentType + '&questionReference=' + questionReference,formData);
    uploadRequest
      .then(async () => {
        console.log('ImageUploaded Successfully');
      })
      .catch((error) => {
        console.log(error);
      });
    };

  // Convert base64 to blob
  base64ToImage(dataURI: String) {
    const fileDate = dataURI.split(',');
    const byteString = atob(fileDate[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([arrayBuffer], { type: 'image/png' });
    return blob;
  }

  viewPhoto = (index : number) => {
    
    const townshipId= this.props.location.state.userData.townshipId;
    const customerId= this.props.location.state.userData.customerId;
    const questionReference = this.state.data[index].questionReference;
    const viewPhotos = apiConstants.viewPhoto + townshipId + '&customerId=' + customerId + '&questionReference=' + questionReference;
    //if(questionReference === this.state.photo[questionReference]) { // If image maintain in state then same call will not have next
      API.authGetRequest(viewPhotos, '')
        .then((res) => {
          if(res.data) {
            const photoObj = Object.assign({}, {[this.state.data[index]?.questionReference]: res?.data}, this.state.photo);
            this.setState({ photo: photoObj });
          }
      })
      // if(this.state.photo[questionReference]!= null){
      //   this.showphoto = true;
      // }
     //};
     
  }

  
  render() {
    return (
      <InsPage>
        <IonPage> 
          <IonHeader>
            <IonToolbar>
              <IonRow>
              <IonCol size="4" >
              <IonItem lines="none" onClick={this.goBack} >
              <IonIcon color = "primary" slot="start" icon={chevronBackSharp} style={{fontSize : "40px", paddingTop: "10px"}} />
              </IonItem>
            </IonCol>
                <IonCol className="ion-align-self-center" style={{ textAlign: "justify" }}>
                  <img src="assets/logo001.png" width="40%" />
                </IonCol>

              <LogoutPage/> 

              </IonRow>
            </IonToolbar>
            <IonToolbar color="secondary">

              <IonTitle>Powered By:<span><b>Septic Smart</b></span></IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent fullscreen>
          
            <IonCard style={{ borderTop: "4px solid #53A658" }}>
              <IonCardHeader style={{ textAlign: "center" }}>
              <IonTitle className="iontitle"><b>{this.state?.headerTO?.title}</b></IonTitle>
              </IonCardHeader>

              {(this.state.data.map((user: any, index: number) => (
               <IonCardContent key={index} className="card_content"> 
                  {(user.answerType === 'text' && user.answer != null) ?
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView}</b> {user.answer} </IonLabel>
                      {/* <IonInput value={user.answer} disabled={user.disableFlag} onIonChange={e => { this.textOnchange(e.detail.value, index) }}></IonInput>  */}
                    </IonItem>
                  </IonCol>
                </IonRow>
                : null}

               {(user.answerType === 'text' && user.answer == null) ?
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView}</b> &nbsp;  N/A </IonLabel>
                      {/* <IonInput value={user.answer} disabled={user.disableFlag} onIonChange={e => { this.textOnchange(e.detail.value, index) }}></IonInput>  */}
                    </IonItem>
                  </IonCol>
                </IonRow>
                : null} 

                {(user.answerType === 'textChange') ?
                <IonRow>
                  <IonCol>
                    <IonItem>
                    <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView}</b> </IonLabel>
                    <IonInput className="ion-text-wrap" value={user.answer} disabled={user.disableFlag} onIonChange={e => { this.textOnchange(e.detail.value, index) }}></IonInput> 
                    </IonItem>
                  </IonCol>
                </IonRow>
                : null} 

              {(user.answerType === 'photo' && user.hideElement) ?
              <IonRow>
                <IonCol>
                  <IonItem disabled={user.disableFlag}>
                    <IonLabel className= "ion-text-wrap"><b>{user.questionNumber} {user.mobileView}</b></IonLabel>
                    <IonFab horizontal="end">
                    <IonFabButton disabled={user.disableFlag}>
                    <IonIcon style = {{fontSize: "w3-tiny"}}icon={camera} onClick={() => this.takePhoto(index)}/>
                    </IonFabButton>
                    </IonFab>
                  </IonItem>
                </IonCol>
              </IonRow>
              : null} 

                  {(user.answerType === 'take photo' && (user.hideElement || user.hideElement == undefined )) ?
                    <IonRow>
                      <IonCol>
                        <IonItem disabled={user.disableFlag}>
                          <IonLabel className="ion-text-wrap" style={{ paddingLeft: '5px'}}><b>{user.questionNumber} {user.mobileView}</b></IonLabel>
                          <IonThumbnail slot = "start" style = {{width : 200, height : 200}}>
                                <IonImg src={'data:image/png;base64,' + this.state.photo[user.questionReference]} onIonImgWillLoad={() => this.viewPhoto(index)}></IonImg>
                            </IonThumbnail>
                          <IonFab horizontal="end">
                            <IonFabButton disabled={user.disableFlag}>
                              <IonIcon style={{ fontSize: "w3-tiny" }} icon={camera} onClick={() => this.takePhoto(index)} />
                            </IonFabButton>
                          </IonFab>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                
                {(user.answerType === '') ?
                  <IonRow>
                    <IonCol>
                      <IonItem>
                        <IonLabel className = "ion-text-wrap">{user.mobileView} </IonLabel>
                      </IonItem>
                    </IonCol>
                  </IonRow>
                  : null}

                {(user.answerType === 'date' && user.answer != null) ?
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className = "ion-text-wrap"><b>{user.questionNumber} {user.mobileView}</b> {moment(user.answer).format('MM/DD/YY')} </IonLabel>
                      {/* <IonInput value={moment(user.answer).format('MM/DD/YYYY')}></IonInput> */}
                      </IonItem>
                  </IonCol>
                </IonRow>
                : null}

                {(user.answerType === 'date' && user.answer === null) ?
                  <IonRow>
                    <IonCol>
                      <IonItem>
                        <IonLabel className = "ion-text-wrap"><b>{user.questionNumber} {user.mobileView}</b> &nbsp; N/A</IonLabel>
                        </IonItem>
                    </IonCol>
                  </IonRow>
                  : null}


               {(user.answerType === 'Main Heading') ?
                  <IonRow>
                    <IonCol>
                      <IonItem>
                        <IonLabel className="iontitle"><b>{user.questionNumber} {user.mobileView}</b></IonLabel>
                      </IonItem>
                    </IonCol>
                  </IonRow>
                  : null}

                {(user.answerType === 'Note' && user.hideElement) ?
                  <IonRow>
                    <IonCol>
                      <IonItem>
                        <IonLabel className = "ion-text-wrap"><b>{user.questionNumber} {user.mobileView}</b></IonLabel>
                      </IonItem>
                    </IonCol>
                  </IonRow>
                  : null}

                  {(user.questionReference == 'comments_any') ?
                  <IonRow>
                  <IonCol>
                    <IonItem>
                      <label style={{color : '#000000'}}><b>{user.questionNumber} {user.mobileView}</b></label>
                      <textarea className="text-wrap" value = {user.answer} style = {{marginLeft : '10%', display : 'flex', width : "50%", height : "100px"}} placeholder = "Please Type Here..." onChange={e => { this.textOnchange(e.target.value, index) }}></textarea>
                      </IonItem>
                  </IonCol>
                  </IonRow>
                  :null}
                

                {(user.answerType === 'radio') ?
                  <IonRow>
                    <IonCol>
                      <IonItem disabled={user.disableFlag}>
                          <IonRadioGroup className = "app-font" value={user.answer} style={{ display: "flex" }} onIonChange={e => { this.radioOnchange(e, index) }}>
             
                            <IonLabel className = "app-font"><b>{user.questionNumber} {user.mobileView}</b></IonLabel>
                            {user.answerValue.split(',').map((el: string, k: number) => (
                              <IonItem key={k} className="ion-item-top-adjust">
                                <IonLabel>{el}</IonLabel>
                                <IonRadio slot="start" value={el} disabled={user.disableFlag} />
                              </IonItem>))}
                          </IonRadioGroup>
                      </IonItem>
                    </IonCol>
                  </IonRow>
                  : null}

                  {(user.answerType === 'choose addon') ?
                    <IonRow>
                      <IonCol>
                        <IonItem disabled={user.disableFlag}>
                          <IonRadioGroup className="app-font" value={user.answer} style={{ display: "flex" }}
                            onIonChange={e => { this.OnChangeRadio(e, this.selectedData.id, index, this.currentPageNumber, this.currentPageRankNumber) }}>
                            <IonLabel className="app-font"><b>{user.questionNumber} {user.mobileView}</b></IonLabel>
                            {user.answerValue.split(',').map((el: string, k: number) => (
                              <IonItem key={k} className="ion-item-top-adjust">
                                <IonLabel>{el}</IonLabel>
                                <IonRadio slot="start" value={el} disabled={user.disableFlag} />
                              </IonItem>))}
                          </IonRadioGroup>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}
          

               {(user.answerType === 'drop down' && (user.hideElement || user.hideElement == undefined )) ?
                  <IonRow>
                    <IonCol>
                      <IonItem>
                        <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView}</b></IonLabel>
                        <IonSelect style={{ width: '500px !important'}} disabled={user.disableFlag} value={user.answer} onIonChange={e => { this.onChangeDrop(e, index) }}>
                          {user.answerValue.split(',').map((el: string, k: number) => (
                            <IonSelectOption  value={el}>{el}</IonSelectOption>
                          ))}
                        </IonSelect>
                      </IonItem>
                      </IonCol>
                  </IonRow>
                  : null}

                  {(user.answerType == 'drop down hide' && user.hideElement) ?
                    <IonRow>
                      <IonCol>
                        <IonItem>
                          <IonLabel className="ion-text-wrap"><b>{user.questionNumber} {user.mobileView}</b></IonLabel>
                          <IonSelect style={{ width: '500px !important' }} disabled={user.disableFlag} value={user.answer} onIonChange={e => { this.onChangeDrop(e, index) }}>
                            {user.answerValue.split(',').map((el: string, k: number) => (
                              <IonSelectOption value={el}>{el}</IonSelectOption>
                            ))}
                          </IonSelect>
                        </IonItem>
                      </IonCol>
                    </IonRow>
                    : null}

                  {((user.answerType === 'multiselect' && user.hideElement) || (user.answerType == 'drop down multiple')) ?
                  <IonRow>
                  <IonCol>
                    <IonItem>
                    <IonLabel className="app-font"><b>{user.questionNumber} {user.mobileView}</b> &nbsp; <IonBadge>{user.answer}</IonBadge></IonLabel>
                      <IonSelect multiple={true} style={{ width: '500px !important',color : "#019849", fontWeight : "bold"}} disabled={user.disableFlag} onIonChange={e => { this.onChangeMultiDrop(e, index) }}>
                        {user.answerValue.split(',').map((el: string, k: number) => (
                          <IonSelectOption value={el}>{el}</IonSelectOption>
                        ))}
                      </IonSelect>
                    </IonItem>
                    </IonCol>
                </IonRow>
                  : null}


                  {(user.answerType === 'range') ?
                  <IonItem className="ion-range-adjust">
                  <IonLabel className = "ion-text-wrap"><b>{user.questionNumber} {user.mobileView}</b> &nbsp; <IonBadge>{this.state.data[index].answer}</IonBadge></IonLabel>
                  <IonRange pin={true} step={user.rangeStep} value={parseInt(user.answer)} disabled={user.disableFlag} min={user.answerValue[0]} max={user.answerValue[1]} color="secondary"
                                  onIonChange={e => { this.rangeUpdate(e.detail.value, index) }}>
                  {(user.label) ? <IonBadge slot="start">{user.label[0]}</IonBadge> : null}
                  {(user.label) ? <IonBadge slot="end">{user.label[1]}</IonBadge> : null}
                  </IonRange>
                  </IonItem>
                          
                  : null}

                  {(user.answerType === 'drain range' && user.hideElement) ?
                  <IonItem className="ion-range-adjust">
                  <IonLabel className = "app-font"><b>{user.questionNumber} {user.mobileView}</b> &nbsp; <IonBadge>{this.state.data[index].answer}</IonBadge></IonLabel>
                  <IonRange pin={true} step={user.rangeStep} value={parseInt(user.answer)} disabled={user.disableFlag} min={user.answerValue[0]} max={user.answerValue[1]} color="secondary"
                                  onIonChange={e => { this.rangeUpdate(e.detail.value, index) }}>
                  {(user.label) ? <IonBadge slot="start">{user.label[0]}</IonBadge> : null}
                  {(user.label) ? <IonBadge slot="end">{user.label[1]}</IonBadge> : null}
                  </IonRange>
                  </IonItem>
                          
                  : null}
                </IonCardContent>
                
              )))}
              {(() => {
           
           if(this.nextPageNumber != 0){
             return ( 
             <IonRow>
                   <IonCol>
                      <IonButton
                      expand="block"
                      onClick={this.updateServiceProgramDetails}
                      class="btncolor">
                      SERVICE QUESTIONS
                      </IonButton>
                    </IonCol>
                  </IonRow>
                   )
                  }
                })()} 

              {(() => {
           
           if(this.nextPageNumber == 0 && this.state.headerTO.title == 'COMMENTS ON PROPERTY'){
             return ( 
              <IonRow>
              <IonCol>
                 <IonButton
                 expand="block"
                 onClick={this.getServiceProgramDetails}
                 class="btncolor">
                 SUBMIT
                 </IonButton>
               </IonCol>
             </IonRow>
            )
         }
       })()} 

            </IonCard>
              
        
          </IonContent>
          </IonPage>
      </InsPage>
    );
  };
}




export interface UserPhoto {
  filepath: string;
  webviewPath?: string;
}

const InsPage = styled(IonPage)`
ion-content{
  --ion-background-color:#cef2d0;
  
}
.ion-button{
  padding: 8px;
  background-color: #019849;
  color:#ffffff;
  border-radius: 4px;
}
ion-card-content{
  font-size: 14px !important;
}
ion-item{
  --ion-background-color:#fff;
}
.card_content{
  margin-top: 0;
  padding: 6px;
  bottom: 2px;
  color : #006884;
  background-color: #ffffff;
  font-size: 14px !important;
}
.btn_ins{
  padding: 8px;
  background-color: #019849;
  color: #fff;
}
.ion-item-top-adjust {
  position: relative;
  top: -10px;

}
.iontitle{
  color : #006884;
  font-size : 18px;
}
.alert-wrapper ion-overlay-wrapper sc-ion-alert-md{
  min-width: -webkit-fit-content;
}
.accordion {
  color : black;
  cursor: pointer;
  border: none;
  text-align: left;
  outline: none;
  font-size: 15px;
  padding : 5px;
  width : 100%;
  transition: 0.4s;
  
}

.ion-text-wrap {
  font-size : 15px;
}

.app-font {
font-size : 15px;
}


`;


export default withIonLifeCycle(ServiceProgramPage);